import Userable from './userable'
export default {
  mixins: [Userable],
  data: () => ({
    loyalty: {loyalty_bonus: 0}
  }),
  methods: {
    loyalty_cancel() {
      this.loyalty.loyalty_bonus = this.computed_loyalty.loyalty_bonus
    },
    async loyalty_save() {
      this.update_loading = true
      if (this.$communicator.then(this, await this.$communicator('update_loyalty', {
        arguments: [this.user['organization']],
        params: this.loyalty
      }))) {
        this.$toast.success("Success", {timeout: 2000});
        this.update_loyalty()
      }
      this.update_loading = false
    },
    async update_loyalty() {
      const loyalty = this.$communicator.then(this, await this.$communicator('loyalty'))
      if (loyalty) {
        this.$store.commit('loyalty', this.$copy(loyalty))
        this.loyalty = this.$copy(loyalty)
      }
    }
  },
  computed: {
    computed_loyalty() {return this.$store.state.loyalty}
  },
  mounted() {
    this.update_loyalty()
  }
}